import React, { Component } from 'react';

export class CampaignReport extends Component {
  render() {
    const { id } = this.props.match.params;
    const src = `https://campaignreports.dolphin-one.com/?campaignId=${encodeURIComponent(id)}`;

    return (
      <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          title='Campaign Report'
          src={src}
          style={{ width: '100%', height: '100%', border: 0 }}
          // sandbox='allow-scripts allow-same-origin allow-forms allow-popups allow-downloads'
          allow='fullscreen'
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screens/CampaignReport.js